const Api = {
    '/api/tags/set-product-tags': 1, //商品打标
    '/api/product-info/edit-product/': 1, //编辑商品机制 
    '/api/product-info/set-handcard': 1, // 上传手卡
    '/api/product-info/edit-product-field': 1, //开启/关闭推广
    '/api/product-group/set-status': 1, // 商品组 开启/关闭推广
    '/api/activity/activity-sync': 1, // 手动确认同步
    '/micro-product-center/sync/business': 1, //抖音手动确认同步
    '/micro-product-center-canary/sync/business': 1, //抖音手动确认同步
    '/api/product-material/batch-add-material': 1, // 商品添加素材
    '/api/product-material/edit-material': 1, // 编辑素材
    '/api/waiting-live/batch-no-sample-live': 1, // 批量无样开播
    '/api/sample-order/direct-batch-add': 1, // 批量申样
}

export default {
    Api
};